// Actions
const SET_PHYSICAL_PONDS = 'SET_PHYSICAL_PONDS';

// Initial State
const initialState = {
  physicalPonds: null,
};

// Reducer
export default function physicalPondsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PHYSICAL_PONDS:
      const { physicalPonds } = action;
      return {
        ...state,
        physicalPonds,
      };
    default:
      return state;
  }
}

// Action Creators
export const setPhysicalPonds = (physicalPonds) => ({
  type: SET_PHYSICAL_PONDS,
  physicalPonds,
});
